import { ga, avocet } from 'js/analytics/adapters'
export const trackSelectPremiumSubscription = ({
  duration,
  discount = 0,
  coupon = '',
  entryPoint = '',
}) => {
  const props = {
    'Subscription Duration': duration,
    'Discount %': discount,
    'Entry Point': entryPoint,
    'Coupon Name': coupon,
  }
  ga.track('Select Premium Subscription', props)
  avocet.track('Select Premium Subscription')
}
